
/* injects from baggage-loader */

'use strict';

import AddBankAccountController from './add-bank-account.controller';
import AddBankAccountTemplate from './add-bank-account.html';

export default class AddBankAccountComponent {
		constructor() {
				this.templateUrl = AddBankAccountTemplate;
				this.controller = AddBankAccountController;
				this.controllerAs = 'ctrl';
				// Bind resolved items to the controller, see module state for resolve
				// this.bindings = { };
		}
}



// WEBPACK FOOTER //
// ./src/app/components/add-bank-account/add-bank-account.component.js